import { createAsyncAction } from 'typesafe-actions';

import { EntityBase } from '../resources/types';

import sagaApi, { PayloadApiFailure, PayloadApiRequest, PayloadApiSuccess } from './sagaApi';

export interface RequestPayload<E extends EntityBase> extends PayloadApiRequest<E> {}

const request = createAsyncAction(
  '@lib/request/REQUEST',
  '@lib/request/SUCCESS',
  '@lib/request/FAILURE',
  '@lib/request/CANCEL',
)<RequestPayload<any>, PayloadApiSuccess<any>, PayloadApiFailure, any>();

// saga
export function* sagaRequest(action: ReturnType<typeof request.request>) {
  const {
    payload: { resource, ...config },
  } = action;

  // @ts-ignore
  return yield sagaApi({
    action: request,
    resource,
    ...config,
  });
}

export default request;
